import { orderBy } from "@progress/kendo-data-query";
import { Button } from "@progress/kendo-react-buttons";
import { ExcelExport, ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { useState } from "react";

//설비별 데이터
const CmpUserByUserMeainInfoGrid = ({ meainCmpPowerList, search, kendo, setLoading }) => {
  const isMobile = localStorage.getItem("isMobile");
  // 엑셀 다운로드 변수 (레퍼런스 사용)
  let _excelData;

  // 정렬
  const [sort, setSort] = useState([{ field: "", dir: "" }]);
  // 정렬 함수
  const onSortChange = (e) => {
    const { sort } = e;
    setSort(sort);
  };

  // 엑셀 다운로드
  const downloadExcel = (e) => {
    setLoading(true);
    _excelData.save();
  };
  const completeExcel = () => {
    setLoading(false);
  };

  return (
    <div className="uk-grid">
      <div className="uk-width-medium-1-1">
        <div className="md-card TBgA">
          <div className="md-card-content small-padding">
            <div className="md-card-toolbar">
              <h3 className="md-card-toolbar-heading-text">
                <Button icon="excel" className="ensoCmpExcelDownBtn" onClick={downloadExcel}>
                  엑셀저장
                </Button>
              </h3>
            </div>
            <ExcelExport
              className="userByUserMeainListGrid"
              data={orderBy(meainCmpPowerList, sort)}
              ref={(exporter) => (_excelData = exporter)}
              fileName={search.userTerm + "_발전량_" + kendo.toString(new Date(), "yyyy-MM-dd")}
              onExportComplete={completeExcel}
            >
              <ExcelExportColumn title="No" field="no" width="100px" />
              <ExcelExportColumn title="CID" field="cid" />
              <ExcelExportColumn title="설비명" field="alias" />
              <ExcelExportColumn title="제조사" field="makrTerm" />
              <ExcelExportColumn title="설비모델" field="meainTypeTerm" />
              <ExcelExportColumn title="에너지원" field="ensoTypeTerm" />
              <ExcelExportColumn title="설비용량" field="instCapa" />
              <ExcelExportColumn title="발전량 & 생산량" field="dayPower" />
              <ExcelExportColumn title="용량대비생산량" field="instCapaPerPower" />
            </ExcelExport>
            <Grid
              id="userByUserMeainListGrid"
              className="userByUserMeainListGrid"
              data={orderBy(meainCmpPowerList, sort)}
              onSortChange={onSortChange}
              sort={sort}
              sortable
            >
              <GridNoRecords>{"해당 수용가의 설비가 존재 하지 않습니다. 설비를 등록 해주세요."}</GridNoRecords>
              <GridColumn title="No" field="no" width={isMobile === "Y" ? 50 : "100px"} />
              <GridColumn title="CID" field="cid" width={isMobile === "Y" ? 115 : "auto"} />
              <GridColumn title="설비명" field="alias" width={isMobile === "Y" ? 100 : "auto"} />
              <GridColumn title="제조사" field="makrTerm" width={isMobile === "Y" ? 115 : "auto"} />
              <GridColumn title="설비모델" field="meainTypeTerm" width={isMobile === "Y" ? 115 : "auto"} />
              <GridColumn title="에너지원" field="ensoTypeTerm" width={isMobile === "Y" ? 115 : "auto"} />
              <GridColumn title="설비용량" field="instCapa" width={isMobile === "Y" ? 115 : "auto"} />
              <GridColumn title="발전량 & 생산량" field="dayEnergy" width={isMobile === "Y" ? 125 : "auto"} />
              <GridColumn title="용량대비생산량" field="instCapaToEnergy" width={isMobile === "Y" ? 140 : "auto"} />
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CmpUserByUserMeainInfoGrid;
